import React, {Component} from "react";
import {Row, Col} from "react-bootstrap";

export default class Hr extends Component {
    render() {
        const classes = "show-grid row " + this.props.small ? 'row-hr-small' : 'row-hr';
        return (
            <Row className={classes}>
                <Col xs={2} xsOffset={5} className="col-hr">
                    <hr/>
                </Col>
            </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Hr.js